import apiClient from '@/lib/axios'
import { UIMessage } from 'ai'
import type { 
  GetChatHistoryParams, 
  ChatHistoryResponse, 
  OutputMetric, 
  CreateFeedbackPayload 
} from '@/api/types/workstation.types'


// Observações [ASK- AGENT] -> A chamada do /ask-agent é realizada no proprio IASDK no arquivo ChatContext.tsx

export const getSuggestedQestions = async (): Promise<string[]> => {
  const response = await apiClient.get<{ questions: string[] }>(`/agent/suggested-questions`)
  return response.data.questions || []
}

export const getChatHistory = async({
  currentPage,
  startDate,
  endDate,
  filter,
  itemsPerPage,
  feedbackFilter = "all",
  metadataFilter = {}
}: GetChatHistoryParams): Promise<ChatHistoryResponse> => {
   // eslint-disable-next-line @typescript-eslint/no-explicit-any
   const params: any = {
      page: currentPage,
      limit: itemsPerPage,
      startDate: startDate?.toISOString(),
      endDate: endDate?.toISOString(),
      feedbackFilter,
    };

    if (filter) {
      params.filter = filter;
    }

    if (metadataFilter && Object.keys(metadataFilter).length > 0) {
      const lowercasedMetadata: Record<string, unknown> = {}
      for (const key in metadataFilter) {
        lowercasedMetadata[key.toLowerCase()] = metadataFilter[key]
      }
      params.metadataFilter = JSON.stringify(lowercasedMetadata);
    }

    const response = await apiClient.get<{ data: OutputMetric[], totalCount: number }>(
    `/dashboard/chat-threads`, 
    { params }
  );
  return response.data;
}


export const getChatThread = async (chatId: string): Promise<{messages: UIMessage[]}> => {
  const response = await apiClient.post(`/chat/get-chat-thread`, {
    chatId
  })
  return response.data;
}

export const addFeedbackToMessage = async (payload: CreateFeedbackPayload) => {
  const response = await apiClient.post("/chat/feedback", payload);
  return response.data;
}

export const removeFeedbackFromMessage = async (messageId: string) => {
  const response = await apiClient.delete(`/chat/feedback/${messageId}`);
  return response.data;
}

export const deleteChat = async (chatId: string) => {
  const response = await apiClient.delete(`/chat/${chatId}`);
  return response.data;
}